import { mutate } from 'swr';
import useMutation from 'use-mutation';

import { usePolicyApi } from '../api/policy-api';
import { routes } from '../bff/routes';
import type {
  GetPolicyByUuidResponse,
  UpdatePolicyBillingBody,
  UpdatePolicyBillingParams,
  UpdatePolicyBillingResponse,
} from '../bff/types';
import { useGetApiCacheKey } from '../utils/hooks/useGetApiCacheKey';

// TODO: should be removed once use-mutation lib types are fixed
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/explicit-module-boundary-types
export function useUpdatePolicyBilling() {
  const policyApi = usePolicyApi();
  const getCacheKey = useGetApiCacheKey();

  return useMutation<
    { params: UpdatePolicyBillingParams; body: UpdatePolicyBillingBody },
    UpdatePolicyBillingResponse | null
  >(({ params, body }) => policyApi.updateBilling(params, body), {
    onSuccess({ input, data }) {
      return mutate(
        getCacheKey(routes.policyByUuid.getUrl(input.params)),
        (current: GetPolicyByUuidResponse): GetPolicyByUuidResponse => data || current,
      );
    },
    throwOnFailure: true,
  });
}
